import React, { useContext } from "react";
import "../account.css";
import "./accountReviews.css";
import { CombinedContext } from "../../../context/combinedContext";
import translations from "../../../translations/translations";
import dayjs from "dayjs";
import { MessageSquareQuote, Star } from "lucide-react";

const AccountReviews = () => {
	const { language } = useContext(CombinedContext);
	const t = translations[language]?.account?.reviews || {};

	// ✅ Placeholder reviews array – replace with real API data
	const myReviews = [
		// {
		// 	shopName: "Barbería Santo",
		// 	rating: 5,
		// 	comment: "Super professional, highly recommend!",
		// 	date: "2024-10-01",
		// }
	];

	return (
		<div className="ac-page aprv">
			<header className="ac-head">
				{/* <span className="ac-eyebrow">{translations[language]?.account?.menu?.reviews || "Reviews"}</span> */}
				<h1 className="ac-title">{t.title}</h1>
				{t.subtitle && <p className="ac-sub">{t.subtitle}</p>}
			</header>

			{myReviews.length === 0 ? (
				<div className="ac-empty">
					<span className="ac-icon is-gold">
						<MessageSquareQuote size={18} />
					</span>
					<p>{t.empty}</p>
				</div>
			) : (
				<div className="aprv-list">
					{myReviews.map((review, index) => (
						<article key={index} className="ac-card">
							<div className="ac-card-head">
								<span className="ac-icon is-gold">
									<Star size={16} />
								</span>
								<h3>
									{review.shopName}
									<span className="ac-card-head-sub">{dayjs(review.date).format("MMM D, YYYY")}</span>
								</h3>
							</div>

							<div className="ac-card-body">
								<div className="aprv-stars" aria-label={`${review.rating} / 5`}>
									{Array.from({ length: 5 }).map((_, i) => (
										<Star key={i} size={14} className={i < review.rating ? "" : "is-off"} fill="currentColor" />
									))}
									<span className="aprv-score">{review.rating}.0</span>
								</div>

								<p className="aprv-comment">{review.comment}</p>
							</div>
						</article>
					))}
				</div>
			)}
		</div>
	);
};

export default AccountReviews;
